<template>
  <div>
    <table class="rm-table">
      <thead>
      <th>ID</th>
      <th>Name</th>
      <th>Description</th>
      </thead>
      <tbody>
      <tr v-for="requirement in selectedRequirements">
        <td>{{requirement.prefix}}{{requirement.display_id ? requirement.display_id : requirement.requirement_id}}</td>
        <td>{{requirement.name}}</td>
        <td><span class="description">{{requirement.description}}</span></td>
      </tr>
      </tbody>

    </table>
  </div>
</template>

<script>
  import utilsMixin from '@/mixins/utils'
  export default {
    data () {
      return {
        selectedRequirements: [],
        contentId: this.$route.query.contentId
      }
    },
    created () {
      this.getLinkedRequirements()
    },
    mixins: [utilsMixin],
    methods: {
      getLinkedRequirements () {
        this.$http.get(
          `/api/requirement/lite?atlassian_content_id=${this.contentId}`,
        ).then(response => {
          this.selectedRequirements = response.data.requirements
        }, response => {
          console.log('error')
        })
      }
    }
  }
</script>

<style scoped>
  .description {
    white-space: pre-wrap;
  }
</style>



// WEBPACK FOOTER //
// ConfluenceLinkedRequirementsMacroView.vue?7e7ccec8